import {Icon} from '../../Icon/Icon';
import {defaultBtn, regularBtn} from './btnTypeRegular';

// ---- Rounded btn ----
export const roundBtnSetup = () => `
    width: var(--rounded-btn-size);
    height: var(--rounded-btn-size);
    min-height: unset;
    padding: 0;
    border-radius: 50%;
    position: relative;
    ${Icon.Wrapper} {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        svg {
            padding: 0 !important;
        }
    }
`;

export const roundBtn = ({color}) => `
    ${roundBtnSetup()};
    ${regularBtn({color})};
`;

export const defaultRoundBtn = () => `
    ${roundBtnSetup()};
    ${defaultBtn()};
`;
